import React from "react";
import LoadingSkeleton from "../components/molecules/LoadingSkeleton";
import ManageStorage from "../utils/manageStorage";
import { Link } from "react-router-dom";
import { DOG_PROFILE, SEARCH } from "../constants/routesPaths";
import {
  getIPAddress,
  PROJECT_NAME,
  serviceAdvertiser,
  serviceRecommendation,
  TRACKING_NORESULTS,
  TRACKING_PARTNER,
  TRACKING_PET,
  TRACKING_RECOMMENDED,
  TYPE_CAT,
  TYPE_DOG,
  VISITS_DOG_PROFILE,
} from "../constants/constants";
import Recommendation from "../models/Recommendation";
import FilterData from "../utils/FilterData";

import vetIcon from "../assets/svgs/health_icon.svg";
import agendaIcon from "../assets/svgs/agenda_green.svg";
import filterIcon from "../assets/svgs/filter_green_icon.svg";
import backgroundFigure from "../assets/svgs/background_figure.svg";
import facebookIcon from "../assets/svgs/facebook_black_icon.svg";
import instagramIcon from "../assets/svgs/instagram_black_icon.svg";
import websiteIcon from "../assets/svgs/website_black_icon.svg";
import phoneIcon from "../assets/svgs/phone_black_icon.svg";
import twitterIcon from "../assets/svgs/twitter_black_icon.svg";
import noResults from "../assets/svgs/noresults.svg";

import Footer from "../components/Footer";
import Tracking from "../models/Tracking";
import { browserName, deviceType, isMobile, mobileVendor, osName } from "react-device-detect";
import CTAButton from "../components/molecules/CTAButtons";
import DataNormalization from "../utils/DataNormalization";
import { vetSlidingData } from "../constants/slideVets";
import Navbar from "../components/Navbar";
import SlidingAdMenu from "../components/SlidingAdMenu";
import { analytics } from "../firebase.config";
import IconButton from "../components/molecules/IconButton";
import { defaultAd } from "../constants/defaultAd";
import AdDetails from "../models/AdDetails";
import { SocialMediaContact } from "../utils/SocialMediaContact";
import ManageSessionStorage from "../utils/manageSessionStorage";
import Notifications from "../components/molecules/Notifications";
import ResultPetContent from "../components/ResultPetContent";

class Results extends React.Component {
  storage = new ManageStorage();
  petData = [];
  petRecommended = [];
  adSpace = {};
  socialMediaLink;
  sessionVisits = null;
  limitResults = 12;
  goToy = 0;
  experimentId = 0;


  constructor(props) {
    super(props);
    let data = this.storage.data;

    const filterData = new FilterData();
    this.sessionVisits = new ManageSessionStorage(VISITS_DOG_PROFILE, 0);

    // llenarlo de los filters
    if (Object.keys(data).length === 0) {
      this.storage.items = filterData.initiateFiltersInStorage();
      // detectar cuales no existen e incluirlos
    } else {
      this.storage.items = {
        ...filterData.initiateFiltersInStorage(),
        ...data,
        ...{fur:[]}
      };
    }

    // window.onscroll = (ev) => {
    //   if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    //       // you're at the bottom of the page
    //       if (((this.state.limitBach - 1) * this.limitResults) <= this.petData.length) {
    //         console.log("Bottom");
    //         const goToY = window.scrollY;
  
    //         setTimeout(() => {
    //           window.scrollTo(0, goToY);
    //           this.setState({
    //             limitBach: this.state.limitBach + 1
    //           });
    //         }, 1000);
    //       }
    //   }
    // };

    data = this.storage.data;
    this.state = { ...data, ...{ loading: false, slidingMenu: false, loadingAd: false, showNotification: false, limitBach: 1, loadingBatch: false} };
  }

  /**
   * 
   * Call API to get the Recommendations
   * 
   */
  async getRecommendations() {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const changeStorageData = {...this.storage.data};
    changeStorageData['age_range'] = changeStorageData['age_range'].map((item) => {
      return item * 12;
    });

    const options = {
      method: "POST",
      body: JSON.stringify(changeStorageData),
      headers: headers,
    };

    const response = await fetch(serviceRecommendation, options);
    if (response.ok) {
      return response.json();
    } else {
      return [];
    }
  }
  
  /**
   * 
   * Call API to get Ads
   * 
   */
  async getAds() {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      body: JSON.stringify({
        id: -1
      }),
      headers: headers,
    };

    const response = await fetch(serviceAdvertiser, options);
    if (response.ok) {
      return response.json();
    } else {
      return defaultAd;
    }

  }

  async trackNoResults() {
    analytics.logEvent(`Action_NoResults`, {
    });
    
    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });
    
    // TRACKING PARA 0 NO_RESULTS
    let tracking = new Tracking({
      eventName: TRACKING_NORESULTS,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: -1,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
      experimentId: this.experimentId
    });

    tracking.trackingPetClick();
  }

  componentDidMount() {
    document.title = `Mascotas en adopción Guatemala | ${PROJECT_NAME}`;
    analytics.logEvent(`Page_Results`, {});
    window.scrollTo(0, 0);
    this.sessionVisits.items = parseInt(this.sessionVisits.data) + 1;

    //Only show the notification every 2 times
    if (parseInt(this.sessionVisits.data) % 2 === 0) {
      setTimeout(() => {
      this.setState({
        showNotification: true,
      });
        setTimeout(() => {
          this.setState({
            showNotification: false,
          });
        }, 7000);
    }, 2000);
    }

    this.getAds().then((data) => {
      // Ad data
      // console.log(data);
      this.adSpace = data;
      this.socialMediaLink = new SocialMediaContact({
        data: this.adSpace,
      });
      this.setState({
        loadingAd: true
      });
    });

    const petDataManupulation = () => {
      analytics.logEvent(`Action_ShowRecommendedPets`, {});
      this.petRecommended.push(this.petData[0]);
      this.petRecommended.push(this.petData[1]);
      this.petRecommended.push(this.petData[2]);

      this.petData.splice(0,3);
    }

    this.getRecommendations().then((data) => {
      this.petData = data.results;
      this.experimentId = data['experiment_id'];

      if (this.petData.length === 0) {
        this.trackNoResults();
      }

      // TODO: Aqui deberia existir un endpoint que llame al API de recomendaciones
      if (this.petData.length > 6 && DataNormalization.getRandomInt(2) === 1)
        petDataManupulation();

      this.setState({
        loading: true,
      });
    });
  }

  activeSlidingMenu() {
    if (!this.state.slidingMenu) {
      analytics.logEvent(`Action_ViewSlidingVets`, {});
    }
    this.setState({
      slidingMenu: !this.state.slidingMenu,
    });
  }

  truncateDescription(description, maxCharacters = 100) {
    if (description.length >= maxCharacters) {
      let truncate = description.substring(0, maxCharacters) + "...";
      return truncate;
    } else {
      return description;
    }
  }

  /**
   * Manage pet click tracking
   *
   * @param {String} id Pet ID
   */
  async clickOverPet(id) {
    analytics.logEvent(`Action_ClickPet`, {
      item: id,
    });

    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });

    let tracking = new Tracking({
      eventName: TRACKING_PET,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: id,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
      experimentId: this.experimentId,
    });

    tracking.trackingPetClick();
  }

  async clickOverPetPartner(id, name) {

    analytics.logEvent(`Action_ResultsAdVet`, {
      item: name,
    });

    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });
    
    let tracking = new Tracking({
      eventName: TRACKING_PARTNER,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: id,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
    });

    tracking.trackingPetClick();
  }

  /**
   * Manage pet recommended click tracking
   *
   * @param {String} id Pet ID
   */
   async clickOverPetRecommended(id) {
    analytics.logEvent(`Action_ClickRecommendedPet`, {
      item: id,
    });

    let ipAddress = await fetch(getIPAddress, {
      method: "GET",
    }).then((data) => {
      return data.json();
    });

    let tracking = new Tracking({
      eventName: TRACKING_RECOMMENDED,
      filters: this.storage.data,
      browser: browserName,
      device: deviceType,
      source: this.props.location.pathname,
      objectId: id,
      ip: ipAddress.IPv4,
      osName: osName,
      mobileVendor: isMobile? mobileVendor: 'notMobile',
      state: ipAddress.state,
      experimentId: this.experimentId,
    });

    tracking.trackingPetClick();
  }

  handleAction() {
    analytics.logEvent(`Action_AdjustSearch`, this.storage.data);
    this.props.history.push(SEARCH);
  }

  handleSeeMore() {
    this.goToy = window.scrollY;
    this.setState({
      loadingBatch: true
    });
    window.scrollTo(0, this.goToy);

    setTimeout(() => {
      this.setState({
        limitBach: this.state.limitBach + 1,
        loadingBatch: false
      });
      window.scrollTo(0, this.goToy);
    }, 1000);
  }

  render() {
    let petCounter = 0;
    let petRecommendedCounter = 0;

    return (
      <div
        className={`${
          this.state.loading === false ? "" : "relative-container"
        }`}
      >
        <Notifications
            text = {`Comparte con nosotros tu experiencia usando Adoptzi. ¡Haz click aquí 👋🏼 ¡`}
            hasLink = {'https://airtable.com/shrIiJH2gVIFTbfKb'}
            customClasses = {`${this.state.showNotification? 'notifications--active notifications--information' : ''}`}
        />

        <img
          className={
            "background-image-abstract background-image-abstract--left-bottom"
          }
          src={backgroundFigure}
          alt={"Imagen de fondo"}
        />

        {/* WHEN LOADING */}
        {this.state.loading === false && (
          <div key={"loading-results"} className={"loading-results"}>
            <h2 className={"loading-title"}>
              Estamos buscando la mejor mascota para ti
            </h2>
            <div className={"skeleton-wrapper"}>
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
            </div>
          </div>
        )}

        {/* WHEN LOADING FINISH */}
        {this.state.loading === true && (
          <div key={"the-results"}>
            <Navbar whiteVersion={true}>
              <div
                onClick={this.activeSlidingMenu.bind(this)}
                className={
                  "navbar__links navbar__links--button navbar__links--button-green-bgwhite"
                }
              >
                <div className={"navbar__links--button-container"}>
                  <img src={agendaIcon} alt={"Icono ver directorio"} />
                  <span>Ver directorio</span>
                </div>
              </div>
              <Link
                to={SEARCH}
                className={
                  "navbar__links navbar__links--button navbar__links--button-green-bggreen"
                }
              >
                <div className={"navbar__links--button-container"}>
                  <img src={filterIcon} alt={"Icono ajustar búsqueda"} />
                  <span>Ajustar búsqueda</span>
                </div>
              </Link>
            </Navbar>
            <div className={"results"}>
              {/* Sliding Menu */}
              <SlidingAdMenu
                vetsData={vetSlidingData}
                // vetsData={[]}
                slidingMenuState={this.state.slidingMenu}
                onClose={this.activeSlidingMenu.bind(this)}
                facebookIcon={facebookIcon}
                instagramIcon={instagramIcon}
                websiteIcon={websiteIcon}
                phoneIcon={phoneIcon}
              />

              <div className={"results-top_options"}>
                <div className={"results-top_options-title"}>
                  <span
                    className={
                      "results-top_options-title_text results-top_options-title_text--bold"
                    }
                  >
                    Resultados:
                  </span>{" "}
                  <span className={"results-top_options-title_text"}>
                    {this.petData.length + this.petRecommended.length} mascotas
                  </span>
                </div>
              </div>

              <div
                className={`results_wrapper ${
                  this.petData.length === 0 ? "results_wrapper__noresults" : ""
                }`}
              >
                {/* NO RESULTS FE */}
                {this.petData.length === 0 && (
                  <div className={`results-noresults`}>
                    <img
                      className={"results-noresults__image"}
                      src={noResults}
                      alt={"No hay resultados de mascotas para tu búsqueda"}
                    />
                    <h3 className={"results-noresults__title"}>
                      ¡Firulais se perdió!
                    </h3>
                    <div className={"results-noresults__texts"}>
                      <p>Tu búsqueda no encontró ningún resultado.</p>
                      <p>Vuelve a intentarlo.</p>
                    </div>
                    <CTAButton
                      buttonText={"Ajustar búsqueda"}
                      onAction={this.handleAction.bind(this)}
                    />
                  </div>
                )}
                {/* FE para recomendaciones */}
                {
                  this.petRecommended.length > 0 && 
                  <div className="results-recommended">
                    <div className="results-recommended-container">
                      <p className="results-recommended-title">Tus top 3 recomendaciones</p>
                      <div className="results-recommended-content">
                      {this.petRecommended.map((pet) => {
                        petRecommendedCounter++;
                        let dogContent = (
                          <div
                            onClick={() => {
                              this.clickOverPetRecommended(pet[Recommendation.id]);
                            }}
                            key={`${pet[Recommendation.petname]}-${
                              pet[Recommendation.id]
                            }`}
                            className={"results_item-wrapper"}
                          >
                            <Link to={`${DOG_PROFILE}${pet[Recommendation.id]}/`}>
                              <div className={"results_item"}>
                                <div className={"results_item_image"}>
                                  <img
                                    src={pet[Recommendation.image][0]}
                                    alt={pet[Recommendation.petname]}
                                  />
                                  {petRecommendedCounter === 1 && (
                                    <span className={"results_item_badge"}>
                                      {DataNormalization.petSexMostVisits(
                                          pet[Recommendation.sex]
                                        )}
                                    </span>
                                  )}
                                </div>
                                <div className={"results_item_information"}>
                                  <div className={"results_item_information-text"}>
                                    <p
                                      className={
                                        "results_item_information-text-title"
                                      }
                                    >
                                      {pet[Recommendation.petname]}
                                    </p>
                                    <p
                                      className={
                                        "results_item_information-text-description"
                                      }
                                    >
                                      {this.truncateDescription(
                                        pet[Recommendation.description]
                                      )}
                                    </p>
                                    <div
                                      className={
                                        "results_item_information-properties"
                                      }
                                    >
                                      <span className={"pet_badge pet_badge--sex"}>
                                        {DataNormalization.petSexString(
                                          pet[Recommendation.sex]
                                        )}
                                      </span>
                                      <span className={"pet_badge pet_badge--size"}>
                                        {DataNormalization.petSizeString(
                                          pet[Recommendation.size], pet[Recommendation.sex]
                                        )}
                                      </span>
                                      <span
                                        className={"pet_badge pet_badge--age"}
                                      >{`Edad: ${DataNormalization.petAge(pet[Recommendation.age])}`}</span>
                                    </div>
                                  </div>
                                  <CTAButton
                                    buttonText={"Ver detalles"}
                                    onAction={() => {}}
                                    position={"right"}
                                    image={
                                      pet[Recommendation.type] === TYPE_DOG
                                        ? "svgs/dog_white_icon.svg"
                                        : pet[Recommendation.type] === TYPE_CAT
                                        ? "svgs/cat_white_icon.svg"
                                        : ""
                                    }
                                    customClasses={"results-cta-button"}
                                  />
                                </div>
                              </div>
                            </Link>
                          </div>
                        );

                        return dogContent;
                      })}
                      </div>
                    </div>
                  </div>
                }
                {this.petData.length > 0 &&
                  this.petData.map((pet) => {
                    petCounter++;

                    if (petCounter <= (this.state.limitBach  * this.limitResults) && petCounter <= (this.petData.length + this.petRecommended.length + 1)) {
                      let dogContent = (
                        <div
                          onClick={() => {
                            this.clickOverPet(pet[Recommendation.id]);
                          }}
                          key={`${pet[Recommendation.petname]}-${
                            pet[Recommendation.id]
                          }`}
                          className={"results_item-wrapper"}
                        >
                          <Link to={`${DOG_PROFILE}${pet[Recommendation.id]}/`}>
                            <div className={"results_item"}>
                              <div className={"results_item_image"}>
                                <img
                                  src={pet[Recommendation.image][0]}
                                  alt={pet[Recommendation.petname]}
                                />
                                {(petCounter === 1 && this.petRecommended.length === 0) && (
                                  <span className={"results_item_badge"}>
                                    {DataNormalization.petSexMostVisits(
                                        pet[Recommendation.sex]
                                      )}
                                  </span>
                                )}
                              </div>
                              <div className={"results_item_information"}>
                                <div className={"results_item_information-text"}>
                                  <p
                                    className={
                                      "results_item_information-text-title"
                                    }
                                  >
                                    {pet[Recommendation.petname]}
                                  </p>
                                  <p
                                    className={
                                      "results_item_information-text-description"
                                    }
                                  >
                                    {this.truncateDescription(
                                      pet[Recommendation.description]
                                    )}
                                  </p>
                                  <div
                                    className={
                                      "results_item_information-properties"
                                    }
                                  >
                                    <span className={"pet_badge pet_badge--sex"}>
                                      {DataNormalization.petSexString(
                                        pet[Recommendation.sex]
                                      )}
                                    </span>
                                    <span className={"pet_badge pet_badge--size"}>
                                      {DataNormalization.petSizeString(
                                        pet[Recommendation.size], pet[Recommendation.sex]
                                      )}
                                    </span>
                                    <span
                                      className={"pet_badge pet_badge--age"}
                                    >{`Edad: ${DataNormalization.petAge(pet[Recommendation.age])}`}</span>
                                  </div>
                                </div>
                                <CTAButton
                                  buttonText={"Ver detalles"}
                                  onAction={() => {}}
                                  position={"right"}
                                  image={
                                    pet[Recommendation.type] === TYPE_DOG
                                      ? "svgs/dog_white_icon.svg"
                                      : pet[Recommendation.type] === TYPE_CAT
                                      ? "svgs/cat_white_icon.svg"
                                      : ""
                                  }
                                  customClasses={"results-cta-button"}
                                />
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
  
                      // Return ad
                      if (petCounter === 3) {
                        petCounter++;
                        if (this.state.loadingAd === false) {
                          return(
                            <React.Fragment>
                              <LoadingSkeleton />
                              {dogContent}
                            </React.Fragment>
                          )
                        } else {
                          return (
                            <React.Fragment>
                              <div
                                key={"ads-for-pets"}
                                className={"results_item-wrapper"}
                              >
                                <div
                                  className={
                                    "results_item results_item--publicidad"
                                  }
                                >
                                  <div className={"results_item_image"}>
                                    <img
                                      src={this.adSpace[AdDetails.image]}
                                      alt={"Publicidad Adoptzi"}
                                    />
                                  </div>
                                  <div className={"results_item_information"}>
                                    <div
                                      className={"results_item_information-text"}
                                    >
                                      <div
                                        className={
                                          "results_item_information-properties"
                                        }
                                      >
                                        <span className={""}>Anuncio</span>
                                      </div>
                                      <p
                                        className={
                                          "results_item_information-text-title"
                                        }
                                      >
                                        {this.adSpace[AdDetails.objectname]}
                                      </p>
                                      <p
                                        className={
                                          "results_item_information-text-description"
                                        }
                                      >
                                        {this.adSpace[AdDetails.shortDescription]}
                                      </p>
                                      <div className={"vet-menu-item--social"}>
                                        {typeof this.adSpace[AdDetails.socialMedia]
                                          .facebook !== "undefined" &&
                                          this.adSpace[AdDetails.socialMedia]
                                            .facebook !== "" && (
                                            <a
                                              className={
                                                "vet-menu-item--social-item"
                                              }
                                              target={"_blank"}
                                              rel={"noreferrer"}
                                              href={
                                                this.adSpace[AdDetails.socialMedia]
                                                  .facebook
                                              }
                                            >
                                              <img
                                                src={facebookIcon}
                                                alt={"Facebook icon"}
                                              />
                                            </a>
                                          )}
                                        {typeof this.adSpace[AdDetails.socialMedia]
                                          .instagram !== "undefined" &&
                                          this.adSpace[AdDetails.socialMedia]
                                            .instagram !== "" && (
                                            <a
                                              className={
                                                "vet-menu-item--social-item"
                                              }
                                              target={"_blank"}
                                              rel={"noreferrer"}
                                              href={
                                                this.adSpace[AdDetails.socialMedia]
                                                  .instagram
                                              }
                                            >
                                              <img
                                                src={instagramIcon}
                                                alt={"Instagram icon"}
                                              />
                                            </a>
                                          )}
                                          {typeof this.adSpace[AdDetails.socialMedia]
                                          .twitter !== "undefined" &&
                                          this.adSpace[AdDetails.socialMedia]
                                            .twitter !== "" && (
                                            <a
                                              className={
                                                "vet-menu-item--social-item"
                                              }
                                              target={"_blank"}
                                              rel={"noreferrer"}
                                              href={
                                                this.adSpace[AdDetails.socialMedia]
                                                  .twitter
                                              }
                                            >
                                              <img
                                                src={twitterIcon}
                                                alt={"Twitter icon"}
                                              />
                                            </a>
                                          )}
                                        {typeof this.adSpace[AdDetails.socialMedia]
                                          .website !== "undefined" &&
                                          this.adSpace[AdDetails.socialMedia]
                                            .website !== "" && (
                                            <a
                                              className={
                                                "vet-menu-item--social-item"
                                              }
                                              target={"_blank"}
                                              rel={"noreferrer"}
                                              href={
                                                this.adSpace[AdDetails.socialMedia]
                                                  .website
                                              }
                                            >
                                              <img
                                                src={websiteIcon}
                                                alt={"Website icon"}
                                              />
                                            </a>
                                          )}
                                          {typeof this.adSpace[AdDetails.phone] !== "undefined" &&
                                          this.adSpace[AdDetails.phone] !== "" && (
                                            <a
                                              className={
                                                "vet-menu-item--social-item"
                                              }
                                              target={"_blank"}
                                              rel={"noreferrer"}
                                              href={`tel://${this.adSpace[AdDetails.phone]}`}
                                            >
                                              <img
                                                src={phoneIcon}
                                                alt={"Phone icon"}
                                              />
                                            </a>
                                          )}
                                      </div>
                                    </div>
                                    <IconButton
                                      buttonText={"Contactar"}
                                      goTo={this.socialMediaLink?.buildLink()}
                                      otherTab={true}
                                      onClick={() => {
                                        this.clickOverPetPartner(this.adSpace[AdDetails.id], this.adSpace[AdDetails.objectname]);
                                      }}
                                      customClasses={"results-cta-button"}
                                    />
                                  </div>
                                </div>
                              </div>
    
                              {dogContent}
                            </React.Fragment>
                          );
                        }
                      }
                      return dogContent;
                    }

                    return <React.Fragment></React.Fragment>;

                  })}
              </div>
              {/* WHEN LOADING */}
              {this.state.loadingBatch === true && (
                <div key={"loading-results"} className={"loading-results"}>
                  <div className={"skeleton-wrapper"}>
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                    <LoadingSkeleton />
                  </div>
                </div>
              )}
              {(this.state.limitBach * this.limitResults < (this.petData.length + this.petRecommended.length + 1)) && 
              <div className="results_loadMore">
                <CTAButton
                    buttonText={"Ver más mascotas"}
                    onAction={this.handleSeeMore.bind(this)}
                    customClasses={"results-cta-button"}
                  />
              </div>
              }
            </div>
            <Footer />
          </div>
        )}
      </div>
    );
  }
}

export default Results;
